import clsx from "clsx"
import { INTERNAL_NETWORK_BADGE } from "../../constants/blockchains"

export const InternalBadge = ({
  size = "md",
  className,
}: {
  size?: "sm" | "md"
  className?: string
}) => (
  <span
    className={clsx(
      "inline-flex shrink-0 items-center rounded-lg bg-green-100 font-semibold text-green-700 dark:bg-green-500/10 dark:text-green-500",
      size === "md" && "gap-x-1.5 px-2 py-1 text-xs/none",
      size === "sm" && "gap-x-1 px-1.5 py-1 text-xs/none",
      className
    )}
    data-testid="internal-network-badge"
  >
    <span
      aria-hidden="true"
      className="size-1.5 shrink-0 rounded-full bg-green-600 dark:bg-green-500"
    />
    {INTERNAL_NETWORK_BADGE}
  </span>
)
